import { render, staticRenderFns } from "./ThemeColorSelector.vue?vue&type=template&id=c8f27952&scoped=true"
import script from "./ThemeColorSelector.vue?vue&type=script&lang=js"
export * from "./ThemeColorSelector.vue?vue&type=script&lang=js"
import style0 from "./ThemeColorSelector.vue?vue&type=style&index=0&id=c8f27952&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f27952",
  null
  
)

export default component.exports